import { useEffect, useState } from 'react';
import FileManagement from '@components/file-management';
import OperationHistoryFilter from '@components/filters/operation-history';
import { ROUTES } from 'constants/routes';
import { operationHistoryCustomerDeliveryFilesListColumns } from './list-data';
import { getCustomerDeliveryDownloadListDetail } from 'shared/helpers/operation-history/get-customer-delivery-download-list';
import { useLocation, useNavigate } from 'react-router-dom';
import { checkPayloadObject } from 'shared/helpers/checkPayloadObject';

type listDataType = {
  page: number;
  size: number;
  sortName: string;
  sortType: string;
  schGroup: 'subject_filename' | 'remote_ip';
  schKeyword: string;
  adminConfigEnv: {
    cssJsVersion: string;
  } | null;
  otmHistDownloadList:
  | [
    {
      fileTotalCnt: number;
      fileTotalSize: number;
      histDt: string;
      histSeq: string;
      otmSubject: string;
      remoteIp: string;
    },
  ]
  | [];
  totalCount: number;
};

const CustomerDeliveryDownloadFilesPage = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const [isLoading, setLoading] = useState<boolean>(false)
  const initialData: listDataType = {
    page: 1,
    size: 10,
    sortName: '',
    sortType: '',
    schGroup: 'subject_filename',
    schKeyword: '',
    adminConfigEnv: null,
    otmHistDownloadList: [],
    totalCount: 0,
  }
  const [listData, setListData] = useState<listDataType>(initialData);

  useEffect(() => {
    const isRefresh = location?.state?.refresh
    const fetchData = async () => {
      setLoading(true)
      await getCustomerDeliveryDownloadListDetail(initialData,
        // @ts-ignore
        [{ key: 'page', value: 1 }, { key: 'schGroup', value: 'subject_filename' }, { key: 'schKeyword', value: '' }],
        setListData,
        ['page', 'schGroup', 'schKeyword'])
      setLoading(false)
    }

    if (isRefresh) {
      fetchData()
    }
  }, [location?.state])

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true)
      await getCustomerDeliveryDownloadListDetail(listData, [], setListData, []);
      setLoading(false)
    }
    fetchData()
  }, []);

  return (
    <FileManagement
      isLoading={isLoading}
      title="고객 전달용 파일 다운로드"
      linkStack={[
        {
          label: 'Home',
          path: ROUTES.OPERATION_HISTORY.CUSTOMER_DELIVERY_DOWNLOAD_FILES.path,
        },
        {
          label: '운영 이력',
          path: ROUTES.OPERATION_HISTORY.CUSTOMER_DELIVERY_DOWNLOAD_FILES.path,
        },
        {
          label: '고객 전달용 파일 다운로드',
          path: ROUTES.OPERATION_HISTORY.CUSTOMER_DELIVERY_DOWNLOAD_FILES.path,
        },
      ]}
      Filter={
        <OperationHistoryFilter
          isLoading={isLoading}
          getFilteredList={async (payload) => {
            setLoading(true)
            await getCustomerDeliveryDownloadListDetail(
              listData,
              payload,
              setListData,
              ['page', 'schGroup', 'schKeyword'],
            )
            if (!checkPayloadObject(payload)) {
              navigate(
                ROUTES.OPERATION_HISTORY.CUSTOMER_DELIVERY_DOWNLOAD_FILES.path,
                { state: { page: payload[0].value, notEmpty: true } }
              )
            }
            setLoading(false)
          }}
        />
      }
      isCreateAction={false}
      type={{
        root: 'OPERATION_HISTORY',
        children: {
          CUSTOMER_DELIVERY_DOWNLOAD_FILES: 'CUSTOMER_DELIVERY_DOWNLOAD_FILES',
        },
      }}
      listData={{
        columns: operationHistoryCustomerDeliveryFilesListColumns,
        rows: listData?.otmHistDownloadList?.map((item, index) => {
          return {
            id:
              listData.totalCount - (listData.page - 1) * listData.size - index,
            ...item,
          };
        }),
        totalCount: listData.totalCount,
        page: listData.page,
        pageSize: listData.size,
      }}
      getFilteredList={(payload) =>
        getCustomerDeliveryDownloadListDetail(listData, payload, setListData, [
          'sortName',
          'sortType',
        ])
      }
      handlePagination={async (payload) => {
        await getCustomerDeliveryDownloadListDetail(listData, payload, setListData, [
          'page',
        ])
        if (!checkPayloadObject(payload)) {
          navigate(
            ROUTES.OPERATION_HISTORY.CUSTOMER_DELIVERY_DOWNLOAD_FILES.path,
            { state: { page: payload[0].value, notEmpty: true } }
          )
        }
      }}
    />
  );
};

export default CustomerDeliveryDownloadFilesPage;
